var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('base-navigation-bar'),_c('v-main',[_c('router-view')],1),_c('base-footer',{directives:[{name:"show",rawName:"v-show",value:(!_vm.reseller_page),expression:"!reseller_page"}]})],1)}
var staticRenderFns = []

export { render, staticRenderFns }